module.exports = __webpack_public_path__ + "img/logo_QR.b493d372.png";